/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { RoleClaimDtoFromJSON, RoleClaimDtoToJSON, } from './';
export function UserDtoFromJSON(json) {
    return UserDtoFromJSONTyped(json, false);
}
export function UserDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'displayName': !exists(json, 'displayName') ? undefined : json['displayName'],
        'roles': !exists(json, 'roles') ? undefined : json['roles'],
        'userPermissions': !exists(json, 'userPermissions') ? undefined : (json['userPermissions'] === null ? null : json['userPermissions'].map(RoleClaimDtoFromJSON)),
        'hasCollectorAdministratorData': !exists(json, 'hasCollectorAdministratorData') ? undefined : json['hasCollectorAdministratorData'],
    };
}
export function UserDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'email': value.email,
        'displayName': value.displayName,
        'roles': value.roles,
        'userPermissions': value.userPermissions === undefined ? undefined : (value.userPermissions === null ? null : value.userPermissions.map(RoleClaimDtoToJSON)),
        'hasCollectorAdministratorData': value.hasCollectorAdministratorData,
    };
}
